import { FC } from 'react';
import { SeoLinksBlockTypeProps } from './TypeProps';
import { useAppSelector } from '@redux/hooks';
import { getProductSeo } from '@entities/Product';
import { RowLinks, GridLinks } from '@app/shared';
import { useWindowSizing } from '@hooks/useSizeWindow';
import classNames from 'classnames';

import styles from './SeoLinksBlock.module.scss';

export const SeoLinksBlock: FC<SeoLinksBlockTypeProps> = ({ className }) => {
  const { links: seoLinks } = useAppSelector(getProductSeo);
  const isMobile = useWindowSizing(990);
  if (!seoLinks) {
    return null;
  }
  return (
    <div className={classNames(styles.WrapperSeoLinksBlock, className)}>
      <div className={styles.Title}>Смотрите также:</div>
      {isMobile ? <RowLinks links={seoLinks} /> : <GridLinks links={seoLinks} />}
    </div>
  );
};
